import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import RightRail from "./RightRail";
import { TouristBanner } from "./TouristMode";
import { ConciergeChat } from "./ConciergeChat";
import { FeedbackButton } from "../FeedbackButton";
import { PasskeyNudge } from "../PasskeyNudge";
import { RouteBoundary } from "../PageBoundary";
import { OfflineNote } from "../OfflineNote";
import { AI_ENABLED } from "../../featureFlags";
import { SiteFooter } from "./SiteFooter";
import { VerifyEmailBanner } from "./VerifyEmailBanner";

const DashboardLayout = () => {
  const location = useLocation();
  const [mobileNav, setMobileNav] = useState(false);
  const showRail = location.pathname === "/";

  return (
    <div className="min-h-screen bg-background">
      {/* Desktop sidebar */}
      <div className="hidden lg:block fixed inset-y-0 left-0 z-30">
        <Sidebar />
      </div>

      {/* Mobile sidebar */}
      {mobileNav && (
        <div className="lg:hidden fixed inset-0 z-50 flex" data-testid="mobile-sidebar-drawer">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileNav(false)} data-testid="sidebar-backdrop" />
          <div className="relative z-10 animate-in">
            <Sidebar onNavigate={() => setMobileNav(false)} />
          </div>
        </div>
      )}

      <div className="lg:pl-[268px] overflow-x-hidden">
        <div className="max-w-[1500px] mx-auto w-full">
          <div className="px-4 lg:px-6 pt-4">
            <TopBar onMenu={() => setMobileNav((o) => !o)} mobileNav={mobileNav} />
          </div>

          <TouristBanner />

          <div className={`px-4 lg:px-6 py-6 grid gap-6 min-w-0 ${showRail ? "xl:grid-cols-[1fr_340px]" : "grid-cols-1"}`}>
            <div className="min-w-0 w-full space-y-6">
              <VerifyEmailBanner />
              <OfflineNote />
              <RouteBoundary>
                <Outlet />
              </RouteBoundary>
            </div>
            {showRail && (
              <div className="hidden xl:block">
                <RightRail />
              </div>
            )}
          </div>

          <SiteFooter />
        </div>
      </div>
      <FeedbackButton raised={AI_ENABLED} />
      <PasskeyNudge />
      {AI_ENABLED && <ConciergeChat />}
    </div>
  );
};

export default DashboardLayout;
